'use strict';

(function () {
  'use strict';

  angular.module('msTracker').controller('TrackerCtrl', TrackerCtrl);

  TrackerCtrl.$inject = ['user', '$log', '$state', '$timeout', 'moodTrackerSvc', '$sessionStorage', 'NotifyingSvc'];

  /* @ngInject */
  function TrackerCtrl(user, $log, $state, $timeout, moodTrackerSvc, $sessionStorage, NotifyingSvc) {
    var vm = this;
    vm.title = 'TrackerCtrl';
    vm.chartType = $sessionStorage.chartType || 'line';
    vm.monthShift = 0;
    vm.currentNavItem = $state.current.name;
    vm.$onInit = activate;

    vm.openDisclaimerModal = function (requirements) {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'tracker/templates/disclaimer-modal.html',
        controller: 'DisclaimerModalCtrl',
        inputs: {
          requirements: requirements,
          user: user
        }
      });
    };

    vm.openRecordMultipleTrackerValuesModal = function (trackersArray, messageId, defaultMessage) {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'tracker/templates/record-multiple-tracker-values-modal.html',
        controller: 'RecordMultipleTrackerValuesModalCtrl',
        controllerAs: 'vm',
        inputs: {
          trackers: trackersArray,
          messageId: messageId,
          defaultMessage: defaultMessage
        },
        closeCallback: recordNewTrackerEntryCallback
      });
    };

    vm.openEditTrackerListModal = function (trackedMoods) {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'tracker/templates/edit-tracker-list-modal.html',
        controller: 'EditTrackerListModalCtrl',
        inputs: {
          trackers: trackedMoods,
          allMoods: vm.allMoods
        },
        closeCallback: editTrackerListCallback
      });
    };

    ////////////////

    function recordNewTrackerEntryCallback(result) {
      if (result) {
        // Notify other controllers that they need to request fresh data.
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.REFRESH_TRACKER);

        if (_.isArray(result.requirements) && result.requirements.length > 0) {
          $timeout(function () {
            vm.openDisclaimerModal(result.requirements);
          }, 600);
        }
      }
    }

    function editTrackerListCallback(chosenTrackers) {
      vm.trackedMoods = chosenTrackers;
    }

    function updateTrackedMoods() {
      moodTrackerSvc.getTrackedMoods().then(function (data) {
        return vm.trackedMoods = data;
      });
    }

    function activate() {
      $log.debug('Tracker control activate');
      vm.user = user;
      moodTrackerSvc.getAllMoods().then(function (data) {
        return vm.allMoods = data;
      });
      updateTrackedMoods();
      // workaround for md-nav-bar for accessibility
      var navElement = angular.element(document.querySelector('._md-nav-bar-list'));
      navElement.attr('tabindex', '0');
    }
  }
})();